import React from 'react'

import {ThemeModalDrawer, ThemeModalDrawerSection} from '../../../drawer'
import Content from '../../Content'
import type {Props} from './types'

export function ModalMobileAuth({onClose, contentSections}: Props): React.ReactElement<Props> {
  return (
    <ThemeModalDrawer onClose={onClose}>
      <ThemeModalDrawerSection fullHeight>
        <Content sections={contentSections} />
      </ThemeModalDrawerSection>
    </ThemeModalDrawer>
  )
}
